import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { BiCloudUpload } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';

export default function PolicyToolbar({
  parent,
  filterName,
  setFilterName,
  filterDatesRange,
  setFilterDatesRange,
  setFilterParameter,
  filterParameter
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);

  const { LoanTypeDrop, AllEmpMasterDrop, BankDrop } = useGlobalSelector();

  const onFilterName = (event) => {
    setFilterName(event.target.value);
  };

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setFilterName('');
    setFilterParameter({
      loanTypeId: ' ',
      employmentSubTypeId: ' ',
      bankId: null
    });
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.loanTypeId}`
                }}
                value={filterParameter?.loanTypeId}
                onChange={(e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    loanTypeId: e.target.value
                  }));
                }}
              >
                <MenuItem value=" " disabled>
                  Select Loan Type
                </MenuItem>
                {LoanTypeDrop?.length > 0 &&
                  LoanTypeDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.employmentSubTypeId}`
                }}
                value={filterParameter?.employmentSubTypeId}
                onChange={(e) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    employmentSubTypeId: e.target.value
                  }));
                }}
              >
                <MenuItem value=" " disabled>
                  Select Employment Type
                </MenuItem>
                {AllEmpMasterDrop?.map((item, index) => (
                  <MenuItem value={item?.value} key={item?.value}>
                    {item?.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item?.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>

            <Grid item xs>
              <Autocomplete
                id="combo-box-demo"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option?.label}
                renderOption={(props, option) => <li {...props}>{option?.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank Name" />
                )}
                value={BankDrop?.find((item) => item?.value === filterParameter?.bankId) || null}
                onChange={(e, newValue) => {
                  // console.log('newValue', newValue);
                  setFilterParameter((pre) => ({
                    ...pre,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Add New Policy" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => {
                // navigate(`/${parent}/add-policy`);
                navigate(`/${parent}/add-policy`, {
                  state: {
                    rowId: null,
                    pageType: 'Add'
                  }
                });
              }}
            >
              <Icon icon={add} width={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip
            title="Upload"
            placement="top"
            arrow
            onClick={(e) => navigate(`/${parent}/upload-policy`)}
          >
            <IconButton className="squareIconButton">
              <BiCloudUpload size={18} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Policy"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
